import React from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import styles from "./styles.css";
import CloseButton from "../../shared/icon-cross";
import { getFastlyImage } from "../../../utils/helpers/get-image-from-path";
import { imageTypes } from "../../../utils/helpers/cdn-image-url";

const PremiumFeatureModal = ({premiumImages, config, onClose, selectedSlide = 0}) => {
    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrow: true,
        dots: false,
        infinite: false,
        initialSlide: selectedSlide
    };
    return (
        <Modal isOpen={true} close={onClose}>
            <div styleName={"styles.sliderWrapper"}>
                <Slider {...settings}>
                    {(premiumImages || []).map(item => {
                        const {image, featureName} = item;
                        return (
                            <div key={featureName} styleName={"styles.imageWrapper"}>
                                <div styleName="styles.closeButton">
                                    <CloseButton type="white" onClickHandler={onClose} />
                                </div>
                                <img src={getFastlyImage({brandImageHost: config.imageHost}, `/${image}`, imageTypes.spinCarZoomable)} />
                                <p styleName={"styles.caption"}>{featureName}</p>

                            </div>
                        );
                    })}
                </Slider>
            </div>
        </Modal>
    );
};

PremiumFeatureModal.propTypes = {
    premiumImages: PropTypes.array,
    config: PropTypes.object,
    onClose: PropTypes.func,
    selectedSlide: PropTypes.number
};
export default PremiumFeatureModal;
